import type { Studio } from '../api/package/gaming/gaming-domain';

export default function sortProviderByGamesNumber(providers: Studio[]): Studio[] {
  return providers.sort((a, b) => b.gamesTotalCount - a.gamesTotalCount);
}
